export default __webpack_public_path__ + "static/media/kausi16-min.087ab1f8.jpg";